import GenericDictionaryPage from "./GenericDictionaryPage";
import { getDemandOutFormat } from "../api/demandOutFormatApi";

export default function DemandOutFormat() {
    return (
        <GenericDictionaryPage
            tableKey="demandOutFormat"
            fetchData={getDemandOutFormat}
            titleKey="genericDic:demandOutFormat"
            newButtonLabel={({ t }) =>
                t("genericDic:claimReopenReasonButtonNew", {
                    tableName: t("genericDic:demandOutFormat").toLowerCase()
                })
            }
        />
    );
}
